import React, {useRef, useState, useEffect} from 'react';
import styles from './Winners.module.scss'
import panelStyles from '../../Panels.module.scss';
import gsap from 'gsap';
import ImageWrapper from "components/imageWrapper/ImageWrapper";
import {useSelector} from "react-redux";
import {buttonClick} from "utils/Helpers";
import {finalists} from "components/homePanels/e_contest/Finalists.data";
import FinalistCarousel from "components/homePanels/e_contest/finalistCarousel/FinalistCarousel";
import HeaderLogo from "components/headerLogo/HeaderLogo";

const Winners = (props) => {

    const accessible = useSelector(state => state.accessible);
    const foreGround = useRef();
    const backGround = useRef();
    const fixedStage = useRef();
    const [activeFinalist, setActiveFinalist] = useState(null);
    const [activeLightbox, toggleActiveLightbox] =useState(false);

    const logo = useRef();

    const mouseOver = (e) => {
        let node = e.currentTarget;
        let squares = logo.current.querySelectorAll('.square');
        squares.forEach((square)=>{
            if(square !== node){
                gsap.to(square, {duration: .5, transform: 'perspective(100px) translateZ(-10px)'} )
                square.firstChild.style.pointerEvents = 'none'

            }
            gsap.to(node, {duration: .5, transform: 'perspective(100px) translateZ(10px)'} )
            gsap.to(node.firstChild, {duration: .5, opacity: 1, onComplete: ()=>{
                    if(node)node.firstChild.style.pointerEvents = 'inherit'
                }} )
        })

    }

    const mouseOut = (e) => {
        let squares = logo.current.querySelectorAll('.square');
        squares.forEach((square)=>{
            gsap.to(square, {duration: .5, transform: 'perspective(100px) translateZ(0px)'} )
        })
        gsap.to(e.currentTarget.firstChild, {duration: .5, opacity: 0})
    }

    const activateFinalist = (index) => {
        let delay = window.innerWidth > 768 ? 0 : 500;
        setTimeout(()=>{
            setActiveFinalist(index);
        }, delay)
    }

    function setAttributes(index){

        if(!activeLightbox){

            return {
                tabIndex : 0,
                role: 'button',
                "aria-label": `See submissions from ${finalists[index].name}`,
                onClick: ()=>activateFinalist(index),
                onKeyDown: (e)=>buttonClick(e)
            }

        }

    }

    useEffect(()=>{
        toggleActiveLightbox(activeFinalist !== null)
    }, [activeFinalist])

    return (

        <>
        <div ref={fixedStage} className={`${panelStyles.fixedStage} ${styles.stage}`} >

            <HeaderLogo menuClick={()=>props.close()}/>

            <div className={`${panelStyles.hero}`}>
                <div ref={foreGround} className={`${panelStyles.foreGround} ${styles.content}`}>
                    <div className={styles.featuredLogoWrapper}>
                        <div ref={logo} className={styles.featuredLogo}>
                            <div className={`${styles.square1} square`} onMouseOver={mouseOver} onMouseOut={mouseOut} {...setAttributes(9)}>
                                <div>
                                    <div className={styles.title} dangerouslySetInnerHTML={{__html:finalists[9].winnerNameDisplay}}/>
                                </div>
                                <img src={finalists[9].carousel.slice(-1)} alt={`Original By ${finalists[9].name}`}/>
                            </div>
                            <div className={`${styles.square2} square`} onMouseOver={mouseOver} onMouseOut={mouseOut} {...setAttributes(10)}>
                                <div>
                                    <div className={styles.title} dangerouslySetInnerHTML={{__html:finalists[10].winnerNameDisplay}}/>
                                </div>
                                <img src={finalists[10].carousel.slice(-1)} alt={`Original By ${finalists[10].name}`}/>
                            </div>
                            <div className={`${styles.square3} square`} onMouseOver={mouseOver} onMouseOut={mouseOut} {...setAttributes(11)}>
                                <div>
                                    <div className={styles.title} dangerouslySetInnerHTML={{__html:finalists[11].winnerNameDisplay}}/>
                                </div>
                                <img src={finalists[11].carousel.slice(-1)} alt={`Original By ${finalists[11].name}`}/>
                            </div>
                            <div className={`${styles.square4} square`} onMouseOver={mouseOver} onMouseOut={mouseOut} {...setAttributes(12)}>
                                <div>
                                    <div className={styles.title} dangerouslySetInnerHTML={{__html:finalists[12].winnerNameDisplay}}/>
                                </div>
                                <img src={finalists[12].carousel.slice(-1)} alt={`Original By ${finalists[12].name}`}/>
                            </div>
                        </div>
                    </div>

                    <span tabIndex={accessible.siteEntered && !accessible.modalOpen ? 0 : null} role={'button'} aria-label={'Click to view all entries'} onKeyDown={buttonClick}
                           className={`explore ${panelStyles.explore} ${panelStyles.button} ${panelStyles.white} ${styles.button}`} onClick={props.showGallery}>
                                    <span className={`${panelStyles.ctaText}`} dangerouslySetInnerHTML={{__html:'Click to view all entries'}}/><span className={panelStyles.carat}>&rsaquo;&rsaquo;</span>
                                </span>

                </div>

                <div aria-hidden={true} ref={backGround} className={`${panelStyles.backGround}`}>
                    <ImageWrapper set={{
                        400: 'https://msobd-storage.azureedge.net/images/bg-smoke-430x650.jpg',
                        700: 'https://msobd-storage.azureedge.net/images/bg-smoke-800x790.jpg',
                        1250: 'https://msobd-storage.azureedge.net/images/bg-smoke-1350.jpg',
                        default: 'https://msobd-storage.azureedge.net/images/bg-smoke.jpg'
                    }} alt={''}/>
                </div>

            </div>

        </div>

        {activeLightbox && <FinalistCarousel winnersOnly={true} activeFinalist={activeFinalist} setActiveFinalist={setActiveFinalist} close={()=>toggleActiveLightbox(false)}/>}


        </>
    )
};

export default Winners
